import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Checkbox } from "../../components/Checkbox";
import { Loading } from "../../components/Loading";
import { Menu } from "../../components/Menu";
import { MiniHeader } from "../../components/MiniHeader";
import { ConfigType } from "../../contexts/AppConfigContext";
import { useAppConfig } from "../../hooks/useAppConfig";
import { useFilters } from "../../hooks/useFilters";
import { usePluginspace } from "../../hooks/usePluginspace";
import api from "../../services/api";
import ReactSlider from 'react-slider'
import "./index.css";
import { GridType } from "../../contexts/FiltersContext";


type CategoriesType = {
	id: number;
	name: string;
	parent: string;
	code: string;
	variations: number;
	checked: boolean;
};

type GridResponseType = {
	id: number;
	name: string;
	variation: string;
}

export function Filter() {
	const navigate = useNavigate();
	const { pluginspace_id } = useParams();
	const [ categoriesToFilter, setCategoriesToFilter ] = useState<CategoriesType[]>([]);
	const { categories, setCategories, gridFilter, setGridFilter, limits, setLimits } = useFilters();
	const [ grids, setGrids ] = useState<GridType[]>([]);
	const { getAppConfig } = useAppConfig();
	const { getToken, registerAccess } = usePluginspace();
	const [config, setConfig] = useState<ConfigType | void>();
	const [loading, setLoading] = useState(true);
	const [minPrice, setMinPrice] = useState(0);
	const [maxPrice, setMaxPrice] = useState(100);
	const [limitPrice, setLimitPrice] = useState(100)
	const [loadingHeader, setLoadingHeader] = useState(true);

	useEffect(() => {
		getAll();
	}, []);

	async function getAll() {
		setLoading(true);
		await registerAccess('filter');
		await getConfig();
		await getMoreExpensiveProduct();
		await getCategories();
		await getGrid();
		positionValues()
		setLoading(false);
	}

	async function getMoreExpensiveProduct() {
		await api
			.get('/api/variations/expensive',
				{
					headers: {
						Authorization: `Bearer ${await getToken()}`,
					},
				}
			)
			.then(async (response) => {
				if(response.data && response.data.data[0] && response.data.data[0].price){
					setLimitPrice(parseInt(response.data.data[0].price) + 1)
					setMaxPrice(parseInt(response.data.data[0].price) + 1)
				}
				if(limits.length > 1){
					setMinPrice(limits[0])
					setMaxPrice(limits[1])
				}
			})
			.catch((err) => {
				console.log(err);
			});
	}

	async function getGrid() {
		await api
			.get('/api/grid',
				{
					headers: {
						Authorization: `Bearer ${await getToken()}`,
					},
				}
			)
			.then(async (response) => {
				const addGrids = response.data.data.map((grid:GridResponseType) => {
					const variations = JSON.parse(grid.variation);
					const newGrid:any = {
						id: grid.id,
						name: grid.name,
						variations: variations ? Object.entries(variations).map((variation) => ({ name: variation[1], checked: false})) : []
					}
					return newGrid
				})
				if(addGrids && addGrids.length !== gridFilter.length){
					setGrids(addGrids)
				} else {
					setGrids(gridFilter);
				}
			})
			.catch((err) => {
				console.log(err);
			});
	}

	async function getConfig() {
		setLoadingHeader(true);
		setConfig(await getAppConfig());
		setLoadingHeader(false);
	}


	async function getCategories() {
		const conf = await getAppConfig()
            
		const showOutStock = (conf && conf.content && conf.content.pdv && conf.content.pdv.showOutStock) ? conf.content.pdv.showOutStock : false;
		await api
			.get(`/api/classification/product-count?noStock=${showOutStock ? true : false}`,
				{
					headers: {
						Authorization: `Bearer ${await getToken()}`,
					},
				}
			)
			.then(async (responseFilter) => {
				const categoriesValid = responseFilter.data.data.filter((category: CategoriesType) => category.variations >= 0);
				categoriesValid.forEach((category:CategoriesType) => {
					if(categories.includes(category.id.toString())){
						category.checked = true;
					}
				})
				setCategoriesToFilter(categoriesValid);
				
			})
			.catch((err) => {
				console.log(err);
			});
	}

	function checkCategory(id: number){
		const categoriesAtt = categoriesToFilter.map((category) => category);
		categoriesAtt.forEach((category) => {
			if(id === category.id){
				category.checked = !category.checked;
			}
		})
		setCategoriesToFilter(categoriesAtt);
	}

	function checkGrid(name: string){
		const gridsAtt = grids ? grids.map((grid) => grid) : [];
		gridsAtt.forEach((grid) => {
			grid.variations.forEach((variation) => {
				if(variation.name === name) {
					variation.checked = !variation.checked
				}
			})
		})
		setGrids(gridsAtt);
	}

	function positionValues(){
		const scrollLeft:any = document.querySelector('.slider-thumb-0');
		let pItem:any = document.getElementById('min-price');
		if(scrollLeft && scrollLeft.style && pItem && pItem.style ){
			pItem.style.left = `${parseInt(scrollLeft.style.left.split("px").join("")) - 15}px`;
		}
		const scrollRight:any = document.querySelector('.slider-thumb-1');
		pItem = document.getElementById('max-price');
		if(scrollRight && scrollRight.style && pItem && pItem.style ){
			pItem.style.left = `${parseInt(scrollRight.style.left.split("px").join("")) - 15}px`;
		}
		if(!scrollLeft && !scrollRight){
			setTimeout(() => {
				positionValues()
			}, 500)
		}
	}

	return (
		<div className="filter">
			<div className="content-filter">
				{!loadingHeader && (
					<MiniHeader
						name="filter"
						title="Filtros"
						fontColor={
							config?.webappcolor.fontheader
								? config.webappcolor.fontheader
								: "#636363"
						}
						backgroundColor={
							config?.webappcolor.backgroundheader
								? config.webappcolor.backgroundheader
								: "#F5F5F5"
						}
					/>
				)}
				{loading ? (
					<div style={{width: '100%', height: 'calc(100vh)'}}>
						<Loading type='spinningBubbles' color='#FFF' width={64} height={64} />
					</div>
				) : (
					<div className="choose-filters">
						<div className="filter-categories">
							<h2>Filtrar por categoria</h2>
							<div className="category-items">
							{
								categoriesToFilter.map((category) => (
									<div 
										className="category-item" 
										style={category.checked ? 
											{
												backgroundColor: config?.webappcolor.webappbutton ? config?.webappcolor.webappbutton : '#4B4D50',
												color: config?.webappcolor.fontbutton ? config?.webappcolor.fontbutton: '#FFF',
												border: "1px solid " + (config?.webappcolor.webappbutton ? config?.webappcolor.webappbutton : '#4B4D50' ),
											} : 
											{
												backgroundColor: config?.webappcolor.fontbutton ? config?.webappcolor.fontbutton : '#FFF',
												color: config?.webappcolor.webappbutton ? config?.webappcolor.webappbutton: '#4B4D50',
												border: "1px solid " + (config?.webappcolor.webappbutton ? config?.webappcolor.webappbutton : '#4B4D50' ),
											}
										}
										onClick={() => checkCategory(category.id)}
									>
										{category.name}
									</div>
								))
							}
							</div>
						</div>
						{ grids?.map((grid) => (
							<div className="filter-grids">
								<h2>Filtrar por {grid.name.toLowerCase()}</h2>
								<div className="grid-items">
								{
									grid.variations.map((variation) => {
										if(variation.name.includes("#") && (variation.name.length === 4 || variation.name.length === 7)){
											return (
												<div 
													className="grid-item-circle-extern"
													style={variation.checked ? 
														{
															border: "2px solid #5D8ED8",
														} : 
														{
															border: "2px solid #D3D9E8",
														}
													}
												>
													<div 
														className="grid-item-circle" 
														style={{
															backgroundColor: variation.name,
															border: (variation.name === '#FFFFFF' || variation.name === '#FFF') ? '2px solid #D3D9E8' : `2px solid ${variation.name}`
														}}
														onClick={() => checkGrid(variation.name)}
													>
													</div>
												</div>
											)
										} else {
											return (
												<div 
													className="grid-item" 
													style={variation.checked ? 
														{
															backgroundColor: config?.webappcolor.webappbutton ? config?.webappcolor.webappbutton : '#4B4D50',
															color: config?.webappcolor.fontbutton ? config?.webappcolor.fontbutton: '#FFF',
															border: "1px solid " + (config?.webappcolor.webappbutton ? config?.webappcolor.webappbutton : '#4B4D50' ),
														} : 
														{
															backgroundColor: config?.webappcolor.fontbutton ? config?.webappcolor.fontbutton : '#FFF',
															color: config?.webappcolor.webappbutton ? config?.webappcolor.webappbutton: '#4B4D50',
															border: "1px solid " + (config?.webappcolor.webappbutton ? config?.webappcolor.webappbutton : '#4B4D50' ),
														}
													}
													onClick={() => checkGrid(variation.name)}
												>
													{variation.name}
												</div>
											)
										}
									})
								}
								</div>
							</div>
						)) }
						<div className="filter-price-slider">
							<h2>Filtrar por preço</h2>
							<ReactSlider
								className="horizontal-slider"
								thumbClassName="slider-thumb"
								trackClassName="track-slider"
								defaultValue={[minPrice, maxPrice]}
								value={[minPrice, maxPrice]}
								renderThumb={(props, state) => <div {...props}></div>}
								max={limitPrice}
								pearling
								onChange={(value: number[]) => {
									setMinPrice(value[0]); 
									setMaxPrice(value[1]);
									positionValues();
								}}
								minDistance={Math.floor(limitPrice/10)}
							/>
							
							<div className="prices">
								<p className="values-price" id="min-price" style={{position: 'absolute'}}>R${minPrice},00</p>
								<p className="values-price" id="max-price" style={{position: 'absolute'}}>R${maxPrice},00</p>
							</div>
						</div>
						<div className="buttons-filter">
							<button
								className="cancel"
								onClick={() => navigate(-1)}
								style={
									config?.webappcolor.webappbutton &&
									config.webappcolor.fontbutton
										? {
												backgroundColor:
													config.webappcolor
														.fontbutton,
												color: config.webappcolor
													.webappbutton,
												border:
													"1px solid " +
													config.webappcolor
														.webappbutton,
											}
										: {}
								}
							>
								Cancelar
							</button>
							<button
								className="apply"
								onClick={() => {
									const newCategoriesChecked =
										categoriesToFilter.filter(
											(catCheck) =>
												catCheck.checked === true
										);
									const onlyCheckedCategories =
										newCategoriesChecked.map(
											(cat) => cat.id.toString()
										);
									setCategories(onlyCheckedCategories);
									setGridFilter(grids)
									setLimits([minPrice, maxPrice])
									navigate(`/${pluginspace_id}/filter/pdv`);
								}}
								style={
									config?.webappcolor.webappbutton &&
									config.webappcolor.fontbutton
										? {
												backgroundColor:
													config.webappcolor
														.webappbutton,
												color: config.webappcolor
													.fontbutton,
												border:
													"1px solid " +
													config.webappcolor
														.webappbutton,
											}
										: {}
								}
							>
								Aplicar
							</button>
						</div>
					</div>
				)}
				{!loadingHeader && (
					<Menu
						fontColor={
							config?.webappcolor.iconsfooter
								? config?.webappcolor.iconsfooter
								: "#636363"
						}
						activeFontColor={
							config?.webappcolor.highlightfooter
								? config?.webappcolor.highlightfooter
								: "#000"
						}
						backgroundMenu={
							config?.webappcolor.backgroundfooter
								? config?.webappcolor.backgroundfooter
								: "#F5F5F5"
						}
						colorIcons={
							config?.webappcolor.iconsfooter
								? config?.webappcolor.iconsfooter
								: "#636363"
						}
						highlightColorIcons={
							config?.webappcolor.highlightfooter
								? config?.webappcolor.highlightfooter
								: "#636363"
						}
						backgroundCart={config?.webappcolor.backgroundcart ? config.webappcolor.backgroundcart : '#FFBA49'}
						fontCart={config?.webappcolor.fontcart ? config.webappcolor.fontcart : '#000'}
						noSales={
							(config && config?.content && config?.content.pdv && config?.content.pdv.noSales)
								? config.content.pdv.noSales
								: false
						}
					/>
				)}
			</div>
		</div>
	);
}
